export default {
    getToken: state => state.access_token,
    getAuthError: state => state.error,
    getUsername: state => state.username,
    getRoletype: state => state.roletype,
    getRolename: state => state.rolename,
    getMail: state => state.mail,
}